import { render, staticRenderFns } from "./createReward.vue?vue&type=template&id=0686e476&scoped=true&"
import script from "./createReward.vue?vue&type=script&lang=js&"
export * from "./createReward.vue?vue&type=script&lang=js&"
import style0 from "./createReward.vue?vue&type=style&index=0&id=0686e476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0686e476",
  null
  
)

export default component.exports